import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { CognitoService } from '../../services/cognito.service';
import { LabelService } from '../../services/label.service';
import { OutsideClickDirective } from '../../directives/outside-click.directive';
import { TaxonomyListComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-list/taxonomy-list.component';
import { TaxonomyActionsComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-actions/taxonomy-actions.component';
import { TaxonomyService } from '../../services/taxonomy.service';
import { HeaderConfig } from '../../shared/types';
import { TaxonomyVersionActionsComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-version-actions/taxonomy-version-actions.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [OutsideClickDirective, TaxonomyListComponent, TaxonomyActionsComponent, TaxonomyVersionActionsComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @Input() config: HeaderConfig = {
    title: '',
  };
  showDropdown: boolean = false;

  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    public labelService: LabelService,
    private location: Location,
    public taxonomyService: TaxonomyService
  ) {}

  ngOnInit(): void {}

  clickLogout() {
    this.router.navigate(['login']);
    this.showDropdown = false;
    localStorage.clear();
    this.cognitoService.deleteCookies();
    this.cognitoService.clearCookies();
    localStorage.removeItem('authToken');
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onOutsideClick = () => {
    this.showDropdown = false;
  };

  handleBackPress() {
    const currentPath = this.router.url;

    // // Check if the path starts with "/taxonomy-dashboard/" and has an ID after it
    // if (currentPath.startsWith('/taxonomy-dashboard/')) {
    const id = currentPath.replace('/taxonomy-dashboard/', '');
    if (currentPath.startsWith('/taxonomy-dashboard/') && id.trim().length > 0) {
      localStorage.removeItem('selectedTaxonomy');
      this.router.navigate(['/taxonomy-dashboard']);
    } else {
      // Only use location.back() if we're not on a taxonomy subpage
      this.location.back();
    }
  }

  taxoSettingsFlag = false;

  toggleSettings() {
    this.taxoSettingsFlag = true;

    if (this.taxoSettingsFlag) {
      this.router.navigate(['settings']);
    } else {
      this.router.navigate(['taxonomy-dashboard']);
    }
  }
}
